module.exports = __webpack_public_path__ + "static/media/pf.2bd5b79d.svg";